module.exports = __webpack_public_path__ + "static/media/virtual-legal.629267ec.png";